module.exports = __webpack_public_path__ + "static/media/flood_metrics_banner.6c454004.jpg";